// src/components/DivisionButtons.js - task list section 807. Bob 2026-10-26 12:48 ET: "make sure the division between the
// yms and t&e are selected by clicking a button for the craft". One button per division of the installation; the craft
// list beneath shows only the picked division's crafts. Nothing renders when the installation has one division.
import React from 'react';
import { DIVISIONS } from '../data/craftTerms';

export default function DivisionButtons({ value, onPick }) {
  if (DIVISIONS.length < 2) return null;
  return (
    <div role="group" aria-label="Your division" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
      {DIVISIONS.map((d) => (
        <button key={d.id} type="button" aria-pressed={value === d.id} onClick={() => onPick(d.id)}
          className={value === d.id ? 'btn btn-primary' : 'btn btn-secondary'}
          style={{ minWidth: 150, fontWeight: 700 }}>
          {d.label}
        </button>
      ))}
    </div>
  );
}
